// extracted by mini-css-extract-plugin
export default {"iconBtn":"Table2_iconBtn__qxXOF"};